import Flickity from 'flickity';

export default class BecomePartnerForm {
  constructor() {
    this.$el = document.querySelector('.js-become-partner-form')
    if (!this.$el) return;

    this.$carousels = this.$el.querySelectorAll('.js-become-partner-form-logo-carousel');

    this.$carousels.forEach($carousel => new Flickity($carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: 3000,
    }));
  }
}
